/*=========================================================================================
  File Name: moduleRolesMutations.js
  Description: Company Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	// Asigna los permisos al state
	SET_PERMISSIONS(state, permissions) {
		state.permissions = permissions;
	},
	// Asigna los roles al state
	SET_ROLES(state, roles) {
		state.roles = roles;
	},
	// Asigna al state la relacion Rol-permiso
	SET_ROLE_PERMISSIONS(state, role_permissions) {
		state.role_permissions = role_permissions;
	},
	// elimina el ROL seleccionado del state
	REMOVE_ROLE(state, itemId) {
		const ItemIndex = state.roles.findIndex((p) => p.id === itemId);
		state.roles.splice(ItemIndex, 1);
	},
};
